import type { AnalyticsPrecision } from '../../../analyticsModule/types'
import { useCompareDateRangeParams } from './useCompareDateRangeParams/useCompareDateRangeParams'
import { useDateRangeParams } from './useDateRangeParams/useDateRangeParams'
import { usePrecisionParams } from './usePrecisionParams/usePrecisionParams'

type AnalyticsParamsOptions = {
  supportedPrecisions?: AnalyticsPrecision[]
}

export const useAnalyticsParams = ({ supportedPrecisions }: AnalyticsParamsOptions = {}) => {
  const { options: dateRangeOptions, dateRange, setDateRange } = useDateRangeParams()
  const {
    options: compareDateRangeOptions,
    compareDateRange,
    setCompareDateRange,
  } = useCompareDateRangeParams(dateRange)
  const {
    options: precisionOptions,
    precision,
    setPrecision,
  } = usePrecisionParams(dateRange, supportedPrecisions)

  return {
    dateRange: {
      value: dateRange,
      options: dateRangeOptions,
      onSelect: setDateRange,
    },
    compareDateRange: {
      value: compareDateRange,
      options: compareDateRangeOptions,
      onSelect: setCompareDateRange,
    },
    precision: {
      value: precision,
      options: precisionOptions,
      onSelect: setPrecision,
    },
  }
}
